( function () {
	/* eslint-disable max-params */
	'use strict';

	function Login ( $location, dataservice, authService, AUTH_ERROR_MSGS, eulaService, $window, Session, licensesFactory, logger, moment, _, $rootScope ) {
		var self = this;

		self.query        = $location.search();
		self.title        = 'Login';
		self.username     = null;
		self.password     = null;
		self.errorMessage = '';
		self.isChecked    = false;
		self.loading      = false;

		function checkForEula () {
			if ( !authService.isLogged() ) {
				self.showEula = true;
				eulaService.getEula().then( function ( data ) {
					self.eulaMessage = data.EULA.replace( /\[INSERT LINK\]/g, 'https://pd360.com/#privacy' )
						.replace( /href="#privacy"/g, 'href="https://pd360.com/#privacy" target="_blank"' );
				} );
			} else {
				self.username     = null;
				self.password     = null;
				self.errorMessage = '';
				self.showEula     = false;

				$location.path( '/' );
			}
		}

		function checkLicense ( licenses ) {
			var showErrorMessage = true;

			if ( licenses.length > 0 ) {
				var license = _.find( _.filter( licenses, { 'LicenseTypeId' : 1000 } ), function ( item ) {
					return moment().isBefore( item.ExpireDate );
				} );

				if ( license ) {
					showErrorMessage = false;
					checkForEula();
				}
			}

			if ( showErrorMessage ) {
				logger.notifyError( 'Forbidden request.', 'Please try again.' );
				self.errorMessage = AUTH_ERROR_MSGS.loginWithoutLicense;
				self.loading      = false;
				authService.killSession( true );
			}
		}

		function login ( username, password ) {
			if ( !username || !password ) {
				self.errorMessage = AUTH_ERROR_MSGS.loginInvalid;
			} else {
				self.loading = true;
				authService.getAuthentication( username, password )
				.then( function () {
					// Set user info for ZenDesk
					if ( typeof window.setUserInfoForZenDesk !== 'undefined' ) {
						var user = Session.getCredentials();

						window.setUserInfoForZenDesk( user.FirstName + ' ' + user.LastName, user.EmailAddress );
					}

					// get user licenses
					licensesFactory.getUserLicenses().then( function ( res ) {
						checkLicense( res );
					} );
				}, function () {
					self.errorMessage = AUTH_ERROR_MSGS.loginFailed;
					self.loading = false;
				} );
			}
		}

		function reject () {
			authService.killSession();
		}

		function accept () {
			var userCredential = JSON.parse( localStorage.credentials );

			eulaService.postEula( userCredential ).then( function () {
				userCredential.LicenseAccepted = true;

				localStorage.setItem( 'credentials', JSON.stringify( userCredential ) );

				$location.url( '/' );
			} );
		}

		function showLicenseError () {
			if ( $rootScope.prevRoute && $rootScope.prevRoute.params.token && $location.search().error === 'invalid_license' ) {
				logger.notifyError( 'Forbidden request.', 'Please try again.' );
				self.errorMessage = AUTH_ERROR_MSGS.loginWithoutLicense;
			}
		}

		function activate () {
			self.showEula = false;
			showLicenseError();
		}

		activate();

		self.login        = login;
		self.reject       = reject;
		self.accept       = accept;
		self.checkForEula = checkForEula;
	}

	angular
		.module( 'app.login' )
		.controller( 'Login', Login );

	Login.$inject = [ '$location', 'coreservice', 'authService', 'AUTH_ERROR_MSGS', 'eulaService', '$window', 'Session', 'licensesFactory', 'logger', 'moment', '_', '$rootScope' ];
} )( );
